<template>
    <section
        v-if="!showThirdNext"
        class="pop-form pop-sign-log register"
        :class="options.registerClass || ''"
        :style="{ backgroundColor: bgColor }"
    >
        <div v-if="step === 1" class="step1">
            <hgroup>
                <h2 v-if="registerTitle" v-html="registerTitle"></h2>
                <h3 v-if="registerSubTitle" v-html="registerSubTitle"></h3>
            </hgroup>
            <template v-if="showFacebook || showGoogle">
                <ThirdBox
                    theme="classic"
                    :enableFb="showFacebook"
                    :enableGoogle="showGoogle"
                    :fbBtnText="$t('common:fbBtnText')"
                    :googleBtnText="$t('common:googleBtnText')"
                    @auth="authCallback"
                >
                </ThirdBox>
                <p class="desc">
                    <span>{{ $t('or') }}</span>
                </p>
            </template>
            <v-form
                :onSubmit="emailSubmit"
                :onSuccess="emailSubmitSuccess"
                :onError="emailSumbitError"
                ref="form-step1"
                key="step1"
            >
                <v-input
                    name="email"
                    type="email"
                    :placeholder="$t('common:emailAddress') + '*'"
                    required
                    focus
                    clearable
                    @input="onTrackEmail(regType.email)"
                    :validateConfig="{
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': hasUserCallBack
                    }"
                ></v-input>
                <div :class="{'submit':true, disabled:submitDisabled}">
                    <input
                        type="submit"
                        :value="options.submitRegister || $t('common:continue')"
                        :style="options.submitRegisterStyle || {}"
                    />
                </div>
                <p
                    v-show="registerErrorShow || thirdPartErrorShow"
                    class="mg-error"
                >
                    {{ registerErrorMsg || thirdPartErrorMsg }}
                </p>
            </v-form>
            <p class="sign-in">
                {{ $t('common:register.oldHere') }}
                <a
                    class="mg-color"
                    @click.prevent="changeType('login')"
                    rel="noopener noreferrer"
                >{{ $t('common:register.signIn') }}</a
                >
            </p>
            <div
                v-if="options.hasVow && options.agreement"
                class="agree-lender"
            >
                <label>
                    <input type="checkbox" checked name="agree" value="true" />
                    <span class="iconfont icon-checked"></span>
                    <span
                        class="agreement-txt"
                        v-html="options.agreement"
                    ></span>
                </label>
            </div>
        </div>
        <div v-if="step === 2" class="step2">
            <hgroup>
                <h2 v-if="registerTitleTwo" v-html="registerTitleTwo"></h2>
                <h3
                    v-if="registerSubTitleTwo"
                    v-html="registerSubTitleTwo"
                ></h3>
            </hgroup>
            <v-form
                :onSubmit="registerSubmit"
                :onSuccess="registerSubmitSuccess"
                :onError="registerSumbitError"
                ref="form-step2"
                key="step2"
            >
                <template v-if="options.nameType === 2">
                    <v-input
                        name="firstName"
                        type="text"
                        :placeholder="
                            $t('common:firstName') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        focus
                        clearable
                        @input="onTrackName(regType.name)"
                    ></v-input>
                    <v-input
                        name="lastName"
                        type="text"
                        :placeholder="
                            $t('common:lastName') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    ></v-input>
                </template>
                <template v-else-if="options.nameType === 3">
                    <v-input
                        class="half"
                        name="prefix"
                        type="text"
                        :placeholder="
                            $t('common:prefix') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        focus
                        clearable
                    ></v-input>
                    <v-input
                        class="half"
                        name="firstName"
                        type="text"
                        :placeholder="
                            $t('common:firstName') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                        @input="onTrackName(regType.name)"
                    ></v-input>
                    <v-input
                        class="half"
                        name="lastName"
                        type="text"
                        :placeholder="
                            $t('common:lastName') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    ></v-input>
                    <v-input
                        class="half"
                        name="suffix"
                        type="text"
                        :placeholder="
                            $t('common:suffix') +
                                (options.nameRequired ? '*' : '')
                        "
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    ></v-input>
                </template>
                <v-input
                    v-else
                    name="fullname"
                    type="text"
                    :placeholder="
                        $t('common:fullName') +
                            (options.nameRequired ? '*' : '')
                    "
                    :required="options.nameRequired || false"
                    :maxlength="30"
                    focus
                    clearable
                    @input="onTrackName(regType.name)"
                ></v-input>
                <v-input
                    v-if="options.note"
                    name="note"
                    type="text"
                    clearable
                    :placeholder="options.note.text"
                    :required="options.note.required || false"
                    :maxlength="options.note.length || 50"
                ></v-input>
                <v-input
                    name="phone"
                    type="tel"
                    :placeholder="
                        $t('common:register.passwordPlaceholder2', {
                            infix: phoneRequired ? '*' : ''
                        })
                    "
                    :required="phoneRequired"
                    clearable
                    :validateConfig="{
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    }"
                    @input="onTrackPhone(regType.phone)"
                ></v-input>
                <div v-if="!!phoneDesciption" v-html="phoneDesciption"></div>
                <disclaimer :disclaimerUniqId="disclaimerUniqId" @updateChecked="updateChecked" class="pop-register-disclaimer" color="#505050" :bgColor="bgColor" :btnText="options.submitRegisterTwo || $t('common:submit')" />
                <div :class="{'submit':true, disabled:disclaimerSubmitDisabled}" :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''">
                    <input
                        type="submit"
                        :value="options.submitRegisterTwo || $t('common:submit')"
                        :style="options.submitRegisterStyleTwo || {}"
                    />
                </div>
                <p
                    v-show="registerErrorShow || thirdPartErrorShow"
                    class="mg-error"
                >
                    {{ registerErrorMsg || thirdPartErrorMsg }}
                </p>
            </v-form>
        </div>
    </section>
    <third-register-next
        ref="third-next"
        v-else
        :fullname="
            authData.fullname ||
                (authData.firstName
                    ? authData.firstName + ' ' + authData.lastName || ''
                    : authData.lastName || '')
        "
        :email="authData.email"
        :phoneRequired="phoneRequired"
        :thirdPartErrorShow="thirdPartErrorShow"
        :thirdPartErrorMsg="thirdPartErrorMsg"
        :thirdRegisterSubmit="thirdRegisterSubmit"
        :thirdRegisterSubmitSuccess="thirdRegisterSubmitSuccess"
        :thirdRegisterSumbitError="thirdRegisterSumbitError"
        :options="options"
    ></third-register-next>
</template>

<script>
import register from '../register.js';
import thirdPart from '../third-part.js';
import thirdRegisterNextVue from './third-register-next.vue';
import { singleColumn } from '../set-gtm-data-mixins';
export default {
    mixins: [register, thirdPart, singleColumn],
    components: {
        'third-register-next': thirdRegisterNextVue
    }
};
</script>
